export const routesRaporPertentageOparator = [
  {
    path: "/rapor_pertentage_oparator",
    name: "rapor_pertentage_oparator",
    component: () => import("@/views/proje_alt/rapor_pertentage_oparator/index.vue"),
    meta: {
      public: false,
      title: "proje_alt.Pertentage Oparator",
      yetki: { k: [1012802] },
    },
  },
]
